export class CaseUpdatePresetModel  {
    public id: number;
    public name: string;
    public body: string;
    public title: string;
    public accessGroupId?: number;
    public restrictAccessGroupId?: number;
}
